var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-exclamation-mark",style:(_vm.styles),attrs:{"title":_vm.title,"data-test":"base-exclamation-mark"}},[_vm._v(" ! ")])}
var staticRenderFns = []

export { render, staticRenderFns }